export default __webpack_public_path__ + "static/media/Fortnite.494772b8.mp4";